<template>
	<div id="livechat" style="background: white">
		<template v-if="$store.getters.getPackage == 'premium'">
			<div class="row">
				<div class="user-container col-md-3">
					<div id="chattype" class="text-center">
						<a href="javascript:void(0);" @click="changeType('admin')" :class="{'active' : type == 'admin'}" style="border-right: 1px solid #eee;">
							Inbox
						</a>
						<a href="javascript:void(0);" @click="changeType('bot')" :class="{'active' : type == 'bot'}">
							Bot
						</a>
						<div class="clearfix"></div>
					</div>
					<users v-model="selectedUser" :type="'admin'" v-show="type == 'admin'"></users>
					<users v-model="selectedUser" :type="'bot'" v-show="type == 'bot'"></users>
					<keep-alive>
					</keep-alive>
				</div>
				<div class="message-container col-md-6">
					<chatbox v-model="selectedUser"></chatbox>
				</div>
				<div class="col-md-3">
					
				</div>
			</div>
		</template>
		<template v-else>
			<div class="text-center" style="margin-bottom: 25px;">
				<img src="/static/img/assets/setting/premium_alert.png" alt="" style="width: 100%; max-width: 300px">
				<h3>It's time to upgrade.</h3>
				<p>You have reached the limit of your current plan.</p>
				<router-link to="/setting?tab=billing" class="btn btn-primary">Upgrade your plan</router-link>
			</div>
		</template>
	</div>
</template>

<style>
</style>

<script>
import { mapGetters } from 'vuex'
import users from './livechat-users'
import chatbox from './livechat-chatbox'
import api from '@/api'

export default{
	components: {
		'chatbox' : chatbox,
		'users' : users
	},
	data: function(){
		return {
			selectedUser : null,
			type : 'admin'
		}
	},
	mounted: function(){
		var vm = this
		if (vm.$route.query.user) {
			vm.type = vm.$route.query.user == 'bot' ? 'bot' : 'admin'
		}
	},
	computed: {
	    ...mapGetters({
	        selectedBot: 'selectedBot'
	    }),
	},
	methods: {
		changeType: function(name) {
			if (this.type == name) {
				return false
			}
			this.type = name
			this.selectedUser = null
			this.updateRoute()
		},
		updateRoute: function() {
			this.$router.push({
				name: 'chatbot',
				path: '/chatbot', 
				query: { 
					tab: 'livechat',
					user: this.type
				}
			})
			this.routeValue = JSON.stringify(this.$route.query)
		},
	},
	watch: {
		selectedBot: function(newVal, oldVal){
			if (newVal != oldVal) {
				this.selectedUser = null
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/view/livechat/Livechat.vue